import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const StatusIcon = forwardRef<SVGSVGElement, IconProps>(function StatusIcon(
  { color = '', height = 24, width = 25, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.78936 14.1631C4.23762 14.0237 4.71403 14.274 4.85346 14.7223C5.6542 17.2966 7.8109 19.2796 10.4867 19.8252C10.9466 19.919 11.2435 20.3679 11.1497 20.8279C11.0559 21.2879 10.607 21.5847 10.147 21.4909C6.85608 20.8199 4.21276 18.3862 3.23017 15.2272C3.09074 14.7789 3.3411 14.3025 3.78936 14.1631Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0001 5.01641C8.12353 5.01641 4.93569 7.95728 4.55416 11.7351C4.50699 12.2022 4.09012 12.5426 3.62306 12.4954C3.15599 12.4483 2.8156 12.0314 2.86276 11.5643C3.33124 6.92553 7.24339 3.31641 12.0001 3.31641C16.7575 3.31641 20.669 6.93451 21.1375 11.5642C21.1847 12.0312 20.8444 12.4482 20.3774 12.4954C19.9103 12.5427 19.4934 12.2024 19.4461 11.7353C19.0646 7.96497 15.876 5.01641 12.0001 5.01641Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2076 14.2063C20.655 14.3485 20.9024 14.8264 20.7602 15.2738C19.7596 18.4225 17.1254 20.8285 13.8454 21.4992C13.3855 21.5932 12.9364 21.2966 12.8424 20.8367C12.7483 20.3768 13.0449 19.9277 13.5049 19.8336C16.1749 19.2877 18.324 17.327 19.1401 14.759C19.2822 14.3116 19.7602 14.0642 20.2076 14.2063Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
